import React, { useState, useCallback, useEffect, useMemo } from 'react';
import { Modal, Table, Input } from 'antd';
import { getClientsList } from '../../Redux/Apis/user/ApiConfig';
import { debounce } from '../../../src/Utils/common';

const ClientList = ({ openModel, handleCancel }) => {
    const [searchText, setSearchText] = useState('');
    const [data, setData] = useState([]);
    const clientId = localStorage.getItem('client_id');
    const clientName = localStorage.getItem('client_name');

    const handleClose = () => {
        handleCancel();
        setData([]);
        setSearchText('');
    };

    const handleSelect = (record) => {
        localStorage.setItem('client_name', record.name);
        localStorage.setItem('client_id', record.id);
        handleClose();
        window.location.reload();
    };

    const handleUnselectUser = () => {
        localStorage.removeItem('client_name');
        localStorage.removeItem('client_id');
        handleClose();
        window.location.reload();
    };

    const columns = [
        {
            title: 'Client Name',
            dataIndex: 'name',
            key: 'name',
        },
        {
            title: ' ',
            key: 'action',
            render: (record) => (
                <span
                    className='client__table__action__text'
                    onClick={() => {
                        handleSelect(record);
                    }}
                    key={record.id + record.name}>
                    Select
                </span>
            ),
        },
    ];

    const fetchData = async (searchQuery) => {
        try {
            const { data } = await getClientsList(searchQuery);
            setData(data.data);
        } catch (error) {}
    };

    const debouncedSearch = useCallback(
        debounce((queryText) => fetchData(queryText), 500),
        []
    );

    useEffect(() => {
        if (openModel) debouncedSearch(searchText);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [searchText, openModel]);

    const handleSearch = (e) => {
        setSearchText(e.target.value);
    };

    const filteredData = useMemo(
        () =>
            data.filter((item) =>
                item?.name?.toLowerCase()?.includes(searchText?.toLowerCase())
            ),
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [data]
    );

    return (
        <>
            <Modal
                title={<b>Client's Details</b>}
                open={openModel}
                onOk={handleClose}
                onCancel={handleClose}>
                {clientId && (
                    <div className='client__name_wrapper'>
                        <div>
                            Currently Selected View:{' '}
                            <span className='client__text'>{clientName}</span>
                        </div>
                        <div
                            className='unselect__client'
                            onClick={handleUnselectUser}>
                            X
                        </div>
                    </div>
                )}
                <div className='clients__detail__wrapper'>
                    <Input.Search
                        placeholder='Search by Client Name'
                        onChange={handleSearch}
                        style={{ marginBottom: 16, width: '60%' }}
                    />
                    {filteredData.length > 0 && (
                        <div>
                            <b>Total Clients:{filteredData.length} </b>
                        </div>
                    )}
                </div>

                <Table
                    className='client__table'
                    dataSource={filteredData}
                    columns={columns}
                />
            </Modal>
        </>
    );
};

export default ClientList;
